import { API_BASE } from '../utils/constants';

export const getAdminToken = () => localStorage.getItem('adminToken') || '';

export const adminHeaders = (extra = {}) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${getAdminToken()}`,
  ...extra,
});

// Drop-in fetch wrapper that injects the admin Bearer token.
// Handles both JSON and FormData bodies — never sets Content-Type on FormData.
// On 401: dispatches 'admin:unauthorized' so AdminContext can auto-logout.
export const adminFetch = (path, options = {}) => {
  const headers = { ...(options.headers || {}), Authorization: `Bearer ${getAdminToken()}` };
  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  return fetch(`${API_BASE}${path}`, { ...options, headers }).then(res => {
    if (res.status === 401) {
      window.dispatchEvent(new CustomEvent('admin:unauthorized'));
    }
    return res;
  });
};
